import { PopupButton } from "react-calendly";

export default function Calendly() {
  return (
    <div className="cal_div">
      <PopupButton
        url="https://calendly.com/slotit"
        rootElement={document.getElementById("__next")}
        text="Book a demo"
        className="p-1 px-2.5 rounded-full text-indigo-500 hover:text-indigo-400 ring-2 ring-indigo-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400 mr-3"
      />
    </div>
  );
}
